import { Typography, Grid, Paper, Button } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import DoneIcon from '@material-ui/icons/Done'
import EditIcon from '@material-ui/icons/Edit'
import LockIcon from '@material-ui/icons/Lock'
import LockOpenIcon from '@material-ui/icons/LockOpen'
import VisibilityIcon from '@material-ui/icons/Visibility'
import React from 'react'

import { getTranslate } from '../../../localization'
import {
  AllocationHistory,
  SystemReservation
} from '../../../types/inventoryAllocatedList'
import useStyles from './styles/historyItem.styles'

interface HistoryItemProps {
  history: AllocationHistory
  onDetailsClick: (details: SystemReservation[]) => void
  lastIndex: boolean
}

const HistoryItem: React.FC<HistoryItemProps> = ({
  onDetailsClick,
  history,
  lastIndex
}) => {
  const classes = useStyles()
  // Determine the icon and its styling based on the type
  const renderIcon = () => {
    switch (history.action) {
      case 'Allocated':
        return (
          <div className={`${classes.iconWrapper} ${classes.allocateIcon}`}>
            <LockIcon />
          </div>
        )
      case 'Deallocated':
        return (
          <div className={`${classes.iconWrapper} ${classes.deallocateIcon}`}>
            <LockOpenIcon />
          </div>
        )
      case 'Book':
        return (
          <div className={`${classes.iconWrapper} ${classes.reserveIcon}`}>
            <DoneIcon />
          </div>
        )
      case 'Cancel':
        return (
          <div className={`${classes.iconWrapper} ${classes.cancelIcon}`}>
            <ClearIcon />
          </div>
        )
      case 'Modify':
        return (
          <div className={`${classes.iconWrapper} ${classes.modifyIcon}`}>
            <EditIcon />
          </div>
        )
      default:
        return (
          <div className={classes.iconWrapper}>
            <LockIcon />
          </div>
        )
    }
  }

  return (
    <Paper className={classes.container} elevation={0}>
      <div className={classes.outerContainer}>
        {renderIcon()}
        <Typography className={classes.historyText} variant="body1">
          {history.action} <span>{getTranslate('on')}</span>{' '}
          {history.time.slice(0, 11)} <span>{getTranslate('at')}</span>{' '}
          {history.time.slice(11, 16)}
        </Typography>
      </div>
      <div className={classes.outerContainer}>
        <div
          className={!lastIndex ? classes.leftLine : classes.lastIndexLeftLind}
        />
        <Grid container spacing={2} className={classes.rowContainer}>
          <Grid item xs={2} className={classes.rowItem}>
            <Typography variant="body2">{getTranslate('Delta')}</Typography>
            <Typography variant="body1">{history.delta}</Typography>
          </Grid>
          <Grid item xs={3} className={classes.rowItem}>
            <Typography variant="body2">
              {history.action === 'Allocated' ||
              history.action === 'Deallocated'
                ? getTranslate('Allocation Request')
                : getTranslate('Reservation')}
            </Typography>
            <Typography
              variant="body1"
              className={classes.requestLink}
              component="a"
              href={
                history.action === 'Allocated' ||
                history.action === 'Deallocated'
                  ? `/allocate-history/${history.references.requestId}/details`
                  : `/booking/list/${history.references.bookingNumber}/view`
              }
              target="_blank"
              rel="noopener noreferrer">
              {history.action === 'Allocated' ||
              history.action === 'Deallocated'
                ? getTranslate('Go To Attempt')
                : history.references.bookingNumber +
                  ' / ' +
                  history.references.bookingNumber +
                  '-' +
                  history.references.bookingVersion}
            </Typography>
          </Grid>
          <Grid item xs={3} className={classes.rowItem}>
            <Typography variant="body2">{getTranslate('Status')}</Typography>
            <Typography variant="body1" className={classes.successStatus}>
              {getTranslate(history.status)}
            </Typography>
          </Grid>
          <Grid item xs={2} className={classes.rowItem}>
            <Typography variant="body2">{getTranslate('Type')}</Typography>
            <Typography variant="body1">
              {getTranslate(history.operationType)}
            </Typography>
          </Grid>
          <Grid item xs={2} className={classes.rowItem}>
            <Button
              className={classes.detailsButton}
              onClick={() => onDetailsClick(history.systemReservations)}
              variant="text"
              startIcon={<VisibilityIcon />}>
              {getTranslate('Details')}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Paper>
  )
}

export default HistoryItem
